var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-height"},[(_vm.loggedIn)?_c('AccountComponent',{attrs:{"user":_vm.user,"tier":_vm.tier,"number-files":_vm.numberFiles,"manage-billing-url":_vm.manageBillingUrl}}):(_vm.loggedIn === false)?_c('SigninToContinue'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }